import * as React from 'react';
import { Announced } from '@fluentui/react/lib/Announced';
import { TextField, ITextFieldStyles } from '@fluentui/react/lib/TextField';
import {
  DetailsList,
  DetailsListLayoutMode,
  Selection,
  IColumn,
  CheckboxVisibility,
} from '@fluentui/react/lib/DetailsList';
import { MarqueeSelection } from '@fluentui/react/lib/MarqueeSelection';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { defenseFileAssistantDropdownValues } from '../../../common/constants';
import i18next, { t } from 'i18next';

const exampleChildClass = mergeStyles({
  display: 'block',
  marginBottom: '10px',
});

const textFieldStyles: Partial<ITextFieldStyles> = { root: { maxWidth: '300px' } };

export interface IDetailsListBasicExampleItem {
  key: number;
  name: string;
  value: number;
}

export interface IDetailsListBasicExampleState {
  items: IDetailsListBasicExampleItem[];
  selectionDetails: string;
}

interface IProjectsTable {
  data: any;
  type: string;
  getIdsFromTable: any;
  activityReport: boolean;
  setButtonDisability: (can: boolean) => void;
}

export class DefenseFileAssistantTable extends React.Component<
  IProjectsTable,
  IDetailsListBasicExampleState
> {
  private _selection: Selection;
  private _allItems: IDetailsListBasicExampleItem[];
  private _columns: IColumn[];

  private formatProjectName(item: any) {
    return `(${item.pro_codigo}) - ${item.pro_nombre}`;
  }

  constructor(props: IProjectsTable) {
    super(props);

    this._selection = new Selection({
      onSelectionChanged: () => {
        this.setState({ selectionDetails: this._getSelectionDetails() });
      },
      getKey: (item: any) => item.pro_id?.toString()
    });

    // Populate with items for demos.
    this._allItems = this.props.data;
    this._columns = [];

    if (this.props.type == defenseFileAssistantDropdownValues.forProjects) {
      this._columns = [
        {
          key: "proyecto",
          name: t("Proyecto"),
          fieldName: "pro_nombre",
          minWidth: 100,
          maxWidth: 200,
          isResizable: true,
          onRender: (item: any) => this.formatProjectName(item),
        },

        {
          key: "direccion",
          name: t("Dirección"),
          fieldName: "direccion_nombre",
          minWidth: 100,
          maxWidth: 200,
          isResizable: true,
        },
        {
          key: "area",
          name: t("Área"),
          fieldName: "area_nombre",
          minWidth: 100,
          maxWidth: 200,
          isResizable: true,
        },
        {
          key: "colaboradores",
          name: t("# Colaboradores"),
          fieldName: "colaboradores_cant",
          minWidth: 100,
          maxWidth: 200,
          isResizable: true,
        },
      ];
    }
    if (this.props.type == defenseFileAssistantDropdownValues.forIndirectsSettlements) {
      this._columns = [
        {
          key: "liq_id",
          name: t("Id"),
          fieldName: "liq_id",
          minWidth: 100,
          maxWidth: 200,
          isResizable: true,
        },
        {
          key: "liq_nro_factura",
          name: t("Nro. factura"),
          fieldName: "liq_desde",
          minWidth: 100,
          maxWidth: 200,
          isResizable: true,
        },
        {
          key: "periodo",
          name: t("Período seleccionado"),
          fieldName: "liq_desde",
          minWidth: 100,
          maxWidth: 200,
          isResizable: true,
        },
        {
          key: "importe_total",
          name: t("Importe total"),
          fieldName: "importe_total",
          minWidth: 100,
          maxWidth: 200,
          isResizable: true,
        },
        {
          key: "cant_proyectos",
          name: t("# Proyectos"),
          fieldName: "cant_proyectos",
          minWidth: 100,
          maxWidth: 200,
          isResizable: true,
        },
        {
          key: "liq_desde",
          name: t("Cargada el"),
          fieldName: "liq_desde",
          minWidth: 100,
          maxWidth: 200,
          isResizable: true,
        },
        {
          key: "col_nombre",
          name: t("Cargada por"),
          fieldName: "col_nombre",
          minWidth: 100,
          maxWidth: 200,
          isResizable: true,
        },
      ];
    }

    this.state = {
      items: this._allItems,
      selectionDetails: this._getSelectionDetails(),
    };
  }

  public render(): JSX.Element {
    const { items, selectionDetails } = this.state;
    //Acá no se si conviene usar este tipo de tabla de fluent o el componente que usamos en activitycardlist
    if (this.props.data && this.props.data.length > 0) {
      return (
        <div>
          <TextField
            placeholder={t("Buscar proyecto")}
            onChange={this._onFilter}
            styles={{ root: { marginTop: "10px", width: "50%" } }}
            onRenderPrefix={() => (
              <i className="ms-Icon ms-Icon--Search" aria-hidden="true" />
            )}
          />
          <div className={exampleChildClass}>{selectionDetails}</div>
          <Announced message={selectionDetails} />
          <Announced
            message={`Number of items after filter applied: ${
              items ? items.length : "none"
            }.`}
          />
          <MarqueeSelection selection={this._selection}>
            <DetailsList
              className="projects-table"
              items={items}
              columns={this._columns}
              setKey="set"
              layoutMode={DetailsListLayoutMode.justified}
              checkboxVisibility={CheckboxVisibility.always}
              selection={this._selection}
              selectionPreservedOnEmptyClick={true}
              ariaLabelForSelectionColumn="Toggle selection"
              ariaLabelForSelectAllCheckbox="Toggle selection for all items"
              checkButtonAriaLabel="select row"
              onItemInvoked={this._onItemInvoked}
              onShouldVirtualize={() => false}
            />
          </MarqueeSelection>
          {/* <DetailsListView
          keyList={'item1'}
          title={'Test'}
          mode={'test'}
          isGridList={false}
          // virtualize={false}
          //   onItemClick={props.onItemClick}
          listFilters={[]}
          //   quickFilters={props.quickFilters}
          baseUrl={'test'}
          //   mapCard={mapCard}
          filterPanel={'test'}
          shouldUpdate={true}
        ></DetailsListView> */}
          </div>
      );
    } else
      return (
          <div>
            {t('No se han encontrado ')}
            {this._setType()}
            {t(' disponibles para seleccionar')}
          </div>
      );
  }

  private _setType() {
    if (this.props.type == "1") {
      return t("liquidaciones");
    } else if (this.props.type == "2") {
      return t("proyectos");
    }
  }

  private _getSelectionDetails(): string {
    const selectionCount = this._selection.getSelectedCount();

    let idList: any = [];
    for (let i = 0; i < this._selection.getSelectedCount(); i++) {
      let selection = this._selection.getSelection()[i];
      //@ts-ignore
      idList.push(selection.pro_id);
    }
    this.props.getIdsFromTable(idList, this.props.activityReport);

    switch (selectionCount) {
      case 0:
        this.props.setButtonDisability(false);
        return t('0 proyectos seleccionados');
      case 1:
        this.props.setButtonDisability(true);
        //@ts-ignore
        return t('1 proyecto seleccionado: ') + this._selection.getSelection()[0].pro_nombre;
      default:
        this.props.setButtonDisability(true);
        return selectionCount + t(' proyectos seleccionados');
    }
  }

  private _onFilter = (
    ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement> | undefined,
    text: string | undefined
  ): void => {

    // OPCION 1:
    text = text || "";
    const lowerText = text.toLowerCase();
    const selectedItems = this._selection.getSelection() as any[];
    let filteredItems: any[];
    console.log("valor de selectedItems", selectedItems);

    if (text) {
      const matchingItems = this._allItems.filter(
        (i: any) =>
          i.pro_nombre?.toLowerCase().includes(lowerText) ||
          i.pro_codigo?.toLowerCase().includes(lowerText)
      );

      console.log("valor de matchingItems con filtro", matchingItems);

      // Unión entre seleccionados y coincidencias (evita duplicados)
      const selectedIds = new Set(selectedItems.map((s) => s.pro_id));
      console.log("valor de selectedIds con filtro", selectedIds);

      filteredItems = [
        ...selectedItems,
        ...matchingItems.filter((m:any) => !selectedIds.has(m.pro_id)),
      ];
      console.log("valor de filteredItems con filtro", filteredItems);

    } else {
      // Si no hay texto, mostrar todo + mantener seleccionados
      filteredItems = [
        ...selectedItems,
        ...this._allItems.filter(
          (i:any) => !selectedItems.some((s:any) => s.pro_id === i.pro_id)
        ),
      ];
      console.log("valor de filteredItems sin filtro", filteredItems);
    }
    this.setState({ items: filteredItems });
  };

  private _onItemInvoked = (item: IDetailsListBasicExampleItem): void => {};
}
